module.exports = __webpack_public_path__ + "assets/1c8459558bc91c139e6a2cec6a3ffb94.png";